import { useEffect, useState } from "react";
import useLenis from "@/hooks/useLenis";
import { api } from "@/lib/api";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Specials from "@/components/site/Specials";
import TakeawayBoard from "@/components/site/TakeawayBoard";
import TakeawayOrderModal from "@/components/site/TakeawayOrderModal";
import Story from "@/components/site/Story";
import Menus from "@/components/site/Menus";
import FerryTimetable from "@/components/site/FerryTimetable";
import TableBooking from "@/components/site/TableBooking";
import VanLiftModal from "@/components/site/VanLiftModal";
import { SocialRail } from "@/components/site/SocialRail";
import { FloatingBookTable } from "@/components/site/FloatingBookTable";
import Footer from "@/components/site/Footer";

export default function Home() {
  useLenis();
  const [minSpend, setMinSpend] = useState(30);
  const [content, setContent] = useState({
    specials: [], story_heading: "", story_body: "", opening_hours: "",
    socials: { facebook: "", instagram: "", tiktok: "" },
  });
  const [takeaway, setTakeaway] = useState({ enabled: false, delivery_enabled: true, delivery_fee: 8, items: [] });
  const [vanOpen, setVanOpen] = useState(false);
  const [orderOpen, setOrderOpen] = useState(false);

  useEffect(() => {
    api.get("/config").then(({ data }) => setMinSpend(data.minimum_spend)).catch(() => {});
    api.get("/content").then(({ data }) => setContent(data)).catch(() => {});
    api.get("/takeaway").then(({ data }) => setTakeaway(data)).catch(() => {});
  }, []);

  const openVan = () => setVanOpen(true);
  const showTakeaway = takeaway.enabled;

  return (
    <div className="bg-background text-foreground">
      <Navbar />
      <Hero />

      <section id="specials" className="max-w-7xl mx-auto px-5 md:px-8 pt-16 md:pt-24">
        <div className={showTakeaway ? "grid gap-6 lg:grid-cols-2 items-stretch" : ""}>
          <Specials specials={content.specials} centered={!showTakeaway} />
          {showTakeaway && <TakeawayBoard takeaway={takeaway} onOrder={() => setOrderOpen(true)} />}
        </div>
      </section>

      <Story heading={content.story_heading} body={content.story_body} image={content.story_image} />
      <Menus />
      <FerryTimetable onOpenVan={openVan} />
      <TableBooking onOpenVan={openVan} />
      <Footer openingHours={content.opening_hours} />

      <SocialRail socials={content.socials} />
      <FloatingBookTable />
      <VanLiftModal open={vanOpen} onClose={() => setVanOpen(false)} minimumSpend={minSpend} />
      <TakeawayOrderModal open={orderOpen} onClose={() => setOrderOpen(false)} takeaway={takeaway} />
    </div>
  );
}
